import type { SearchParams, SearchResult } from '../../search/hooks/use-search';
import type { CategoryResponse } from '../model/CategoryResponse';
import type { RedirectResponse } from '../model/RedirectResponse';

export interface ContentInfo {
    response?: RedirectResponse | CategoryResponse;
    serverParams?: SearchParams;
    page?: {
        pages: SearchResult[];
        pageParams: number[];
    };
}

export function isCategoryInfo(contentInfo?: ContentInfo): contentInfo is CategoryInfo {
    return !!contentInfo && contentInfo.response?.type === 'CATEGORY';
}

export interface CategoryInfo {
    response?: CategoryResponse;
    serverParams?: SearchParams;
    page?: {
        pages: SearchResult[];
        pageParams: number[];
    };
}
